// We let the backend decide whether to honor the remaining trial period or not. That's why we have
// to reflect in the pricing options shown to the user. With the `trial_period_days` set to 0, the
// endpoint will return the paywall and its prices without any trial period.
export const paywallPresenterOptions = { trial_period_days: 0 };
